import script from "./type_access.vue?vue&type=script&setup=true&lang=js"
export * from "./type_access.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__